export function buildCartLineUpdatePayload(lineId: string, currentQuantity: number, targetQuantity: number) {
  const op = targetQuantity > currentQuantity ? 'up' : 'down'

  return {
    lineId,
    quantity: Math.abs(targetQuantity - currentQuantity),
    op,
    targetQuantity,
  }
}
